import { statsigClient } from '../http/statsig-client'
import { getStatsigEnvTier } from '../session/session'
import { getStatsigDataWithTTL, setStatsigDataWithTTL } from '../utils/storage'
import { STATSIG_READY_EVENT } from '../hooks/useStatsigFeatureGate'

let API_KEY: string | undefined

function notifyStatsigReady() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(STATSIG_READY_EVENT))
  }
}

export async function initialize({ apiKey }: { apiKey: string }) {
  API_KEY = apiKey

  try {
    const cachedData = getStatsigDataWithTTL()

    const envTier = getStatsigEnvTier()

    if (cachedData && envTier === 'production') {
      notifyStatsigReady()

      return
    }

    const response = await statsigClient.initialize()

    if (response.status === 200) {
      setStatsigDataWithTTL(response.data)
      notifyStatsigReady()
    }
  } catch (error) {
    console.error('Error on initialize Statsig:', error)
  }
}

export function getApiKey() {
  return API_KEY
}
